<template>
  <transition name="back-top-fade">
    <div class="back-top" v-show="show" @click.stop="scrollToTop" title="返回顶部">
      <i class="el-icon-arrow-up"></i>
    </div>
  </transition>
</template>

<script>
export default {
  name: "back-top",
  data() {
    return {
      show: false
    }
  },
  methods: {
    scroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.show = scrollTop > 200;
    },
    scrollToTop() {
      const startY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const duration = 400;
      const startTime = performance.now();
      const easeOut = (t) => 1 - Math.pow(1 - t, 3);
      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, startY * (1 - easeOut(progress)));
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, {passive: true});
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  }
}
</script>

<style scoped lang="less">
.back-top {
  position: fixed;
  right: 2.5rem;
  bottom: 5rem;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #4a5d4f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 3px 12px rgba(74, 93, 79, 0.35);
  transition: all 0.3s ease;
}

.back-top:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(74, 93, 79, 0.45);
}

.back-top:active {
  transform: translateY(0);
}

.back-top i {
  font-size: 20px;
  font-weight: 700;
}

/* 进出场动画 */
.back-top-fade-enter-active,
.back-top-fade-leave-active {
  transition: all 0.3s ease;
}

.back-top-fade-enter,
.back-top-fade-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.85);
}
</style>
